import {useMutation} from 'react-query'

import {mutations} from '../../mutations'

export const usePostRequestForQuote = () => {
  return useMutation(mutations.postRequestForQuote)
}
